







































import { Component, Vue, Prop } from 'vue-property-decorator'
import Edit from './Edit.vue'
import { MachineDetail } from '../store/machine'

@Component({ components: { Edit } })
export default class DetailMachine extends Vue {
  @Prop() machine!: MachineDetail

  close() {
    this.$emit('close')
  }
}
